import { getIndividualLessonDurationDefault } from '../IndividualLessonLinkFields/individualLessonLink.utils'

export type GroupPerLessonGroupDefaults = {
  lessonDuration?: number | null
  studentLessonPrice?: number | null
}

/** Дефолты при выборе тарифа group_per_lesson (без группы). */
export const getGroupPerLessonLinkFieldDefaults = (
  tariff?: ICourseTariff | null,
) => {
  const lesson_duration = getIndividualLessonDurationDefault(tariff)
  const tariffFirstPrice = Number(tariff?.first_price)

  return {
    lesson_duration,
    first_price: Number.isFinite(tariffFirstPrice) ? tariffFirstPrice : null,
  }
}

/**
 * Гидрация после выбора группы (ТЗ):
 * lesson_duration: group → tariff → 60
 * first_price: group.student_lesson_price ?? tariff.first_price
 */
export const getGroupPerLessonDefaultsFromGroup = (
  tariff?: ICourseTariff | null,
  group?: GroupPerLessonGroupDefaults | null,
) => {
  const groupDuration = Number(group?.lessonDuration)
  const tariffDuration = Number(tariff?.lesson_duration)
  const lesson_duration =
    Number.isFinite(groupDuration) && groupDuration >= 1
      ? Math.min(1440, Math.trunc(groupDuration))
      : Number.isFinite(tariffDuration) && tariffDuration >= 1
      ? Math.min(1440, Math.trunc(tariffDuration))
      : 60

  const groupPrice = Number(group?.studentLessonPrice)
  const tariffPrice = Number(tariff?.first_price)
  const first_price = Number.isFinite(groupPrice)
    ? groupPrice
    : Number.isFinite(tariffPrice)
    ? tariffPrice
    : null

  return { lesson_duration, first_price }
}

export type GroupPerLessonLessonParams = {
  lesson_duration: number | null
  first_price: number | null
}

/** Сравнение текущих полей формы с источником (тариф / группа). */
export const isSameGroupPerLessonParams = (
  current: GroupPerLessonLessonParams,
  source: GroupPerLessonLessonParams,
) => {
  const currentDuration = Number(current.lesson_duration)
  const sourceDuration = Number(source.lesson_duration)
  const durationEqual =
    Number.isFinite(currentDuration) &&
    Number.isFinite(sourceDuration) &&
    currentDuration === sourceDuration

  const currentPrice = Number(current.first_price)
  const sourcePrice = Number(source.first_price)
  const bothPriceMissing =
    !Number.isFinite(currentPrice) && !Number.isFinite(sourcePrice)
  const priceEqual =
    bothPriceMissing ||
    (Number.isFinite(currentPrice) &&
      Number.isFinite(sourcePrice) &&
      currentPrice === sourcePrice)

  return durationEqual && priceEqual
}

export const formatGroupPerLessonDuration = (
  lesson_duration: number | null | undefined,
) => {
  if (lesson_duration != null && Number.isFinite(Number(lesson_duration))) {
    return `${Number(lesson_duration)} мин`
  }
  return '—'
}

export const formatGroupPerLessonPrice = (
  first_price: number | null | undefined,
) => {
  if (first_price != null && Number.isFinite(Number(first_price))) {
    return `${Number(first_price)} ₽`
  }
  return '—'
}

export const formatGroupPerLessonSourceLabel = ({
  lesson_duration,
  first_price,
}: GroupPerLessonLessonParams) => {
  const durationLabel =
    lesson_duration != null && Number.isFinite(Number(lesson_duration))
      ? `${Number(lesson_duration)} мин`
      : 'длительность не задана'
  const priceLabel =
    first_price != null && Number.isFinite(Number(first_price))
      ? `${Number(first_price)} ₽`
      : 'цена не задана'
  return `${durationLabel}, ${priceLabel}`
}
